import clsx from "clsx";
import Cookies from "js-cookie";
import React, { useEffect, useState, useRef } from "react";
import { blob } from "stream/consumers";
import {
  MetaDataList,
  MetaDataDetails,
  MetaDataDetailsExecute,
  MetaDataDetailsDownload,
  GetApiData,
  GetDyanmicFormApiData,
  FetchSecurityMaster,
} from "../../api/api";
import { Button } from "../../components/Button/Button";
import { TableData } from "./tabledata";
import Switch from "react-switch";
import _ from "lodash";
import { MultiSelect } from "react-multi-select-component";
import {
  NavLink,
  Route,
  Routes,
  Link,
  useLocation,
  useNavigate,
  Navigate,
} from "react-router-dom";
import { filter } from "lodash";
import { BASE_URL, API_KEY } from "../../api/api";

const TaskList = () => {
  const [metaDataList, setMetaDataList] = useState<any>();
  const [selectedId, setSelectedId] = useState<any>(null);
  const [getMetaValue, setGetMetaValue] = useState<any>(null);
  const [selectedName, setSelectedName] = useState<any>(null);
  const [getExecuteValue, setGetExecuteValue] = useState<any>(null);
  const [selectedDate, setSelectedDate] = useState<any>(null);
  const [sectorCount, setSectorCount] = useState<any>(null);
  const [getTaskDownload, setGetTaskDownload] = useState("");
  const [isDownload, setIsDownload] = useState(false);
  const [filterFundId, setFilterFundId] = useState<any>(null);
  const [getFundList, setGetFundList] = useState<any>(null);
  const [showControls, setShowControls] = useState<any>(null);
  const [ToggleButton, setToggleButton] = useState(false);
  const [inputValue, setInputValue] = useState(null);
  const [data, setData] = useState<any>("");
  const selectedClient: any = Cookies.get("client");
  const [fundList, setFundList] = useState<any>(null);
  const [participantList, setParticipantList] = useState<any>(null);
  const [returnType, setReturnType] = useState("dataset");
  const [filteredTaskOptions, setFilteredTaskOptions] = useState<any>([]);
  const [dateValue, setDateValue] = useState("");
  const [dataProcessErrorMsg, setDataProcessErrorMsg] = useState<any>("");
  const [dataSetErrorMsg, setDataSetErrorMsg] = useState<any>([]);

  function handleDateChange(e: any) {
    setDateValue(e.target.value);
    // const dateType = e.target.type;
    // const dateObj = new Date(e.target.value);
    // const year = dateObj.getFullYear();
    // const month = ("0" + (dateObj.getMonth() + 1)).slice(-2);
    // const day = ("0" + dateObj.getDate()).slice(-2);
    // const hours = ("0" + dateObj.getHours()).slice(-2);
    // const minutes = ("0" + dateObj.getMinutes()).slice(-2);
    // const seconds = ("0" + dateObj.getSeconds()).slice(-2);

    // const formattedDate =
    //   dateType === "datetime-local"
    //     ? `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`
    //     : `${year}-${month}-${day}`;
    // //const formattedDate = `${year}-${month}-${day}`;

    // const currentDate = new Date(e.target.value);
    // const day = String(currentDate.getDate() + 1).padStart(2, "0");
    // const month = String(currentDate.getMonth() + 1).padStart(2, "0");
    // const year = currentDate.getFullYear();
    // const formattedDate = `${year}-${month}-${day}`;

    function formatDate(currentDate: string): string {
      const [year, month, day] = currentDate.split("-");
      return `${year}-${month}-${day}`;
    }

    return setData({
      ...data,
      [e.target.name]: formatDate(e.target.value),
    });
  }

  function handleProcessSecurity() {
    if (
      selectedId !== null &&
      selectedDate !== null &&
      selectedName !== "ExportSecurityPositionsData"
    ) {
      MetaDataDetailsExecute(selectedName, selectedDate, Cookies.get("newJwt"))
        .then((response) => response.json())
        .then((response) => {
          setGetExecuteValue(response);
          setSectorCount(response);
        });
    }
  }

  function handleDownload(e: any) {
    return setGetTaskDownload(e.target.value);
  }

  const [SectorCurrentPage, setSectorCurrentPage] = useState(1);

  const SectorpageHandler = (pageNumbers: any, index: any) => {
    setGetExecuteValue(
      sectorCount.slice(pageNumbers * 15 - 15, pageNumbers * 15)
    );
    setSectorCurrentPage(pageNumbers);
  };

  useEffect(() => {
    if (
      filterFundId !== null &&
      selectedId === "6982dd6e-a482-4fb5-b103-2028e454a6d8"
    ) {
      const FundId = filterFundId?.id;
      GetApiData(FundId, "Fund", Cookies.get("newJwt"))
        .then((response) => response.json())
        .then((response) => {
          setGetFundList(response);
        });
    }
  }, [filterFundId]);

  const handleSelectChange = (e: any) => {};
  const handleSelectFundChange = (e: any) => {
    return console.log(e);
  };

  const [selected, setSelected] = useState<any>([]);

  useEffect(() => {
    if (selected[0]?.value) {
      //console.log("selected")
      setDataProcessErrorMsg(null);
      setData(null);
      setDataSetErrorMsg(null);
    }

    // Additional logic or function calls based on the updated value of "selected"
  }, [selected]);

  useEffect(() => {
    if (selected.length > 1) {
      setSelected([selected[selected.length - 1]]);
      setData(null);
      setDateValue("");
    }
  }, [selected]);

  useEffect(() => {
    let selectedResult = selected.map((value: any) => value);
    var taskItem = selectedResult.find((e: any) => e.value);
    setSelectedId(taskItem?.value);
    setSelectedName(taskItem?.label);
  }, [selected]);

  useEffect(() => {
    if (selectedId) {
      MetaDataDetails(selectedId, Cookies.get("newJwt"))
        .then((response) => response.json())
        .then((response) => {
          setGetMetaValue(response);
          setFilterFundId(_.find(response, ["name", "FundID"]));
        });
    }
  }, [selectedId]);

  useEffect(() => {
    const a = _.find(metaDataList, ["name", selectedName]);
    setShowControls(a);
  }, [selectedName]);

  useEffect(() => {
    MetaDataList(Cookies.get("newJwt"))
      .then((response) => response)
      .then((response) => {
        setMetaDataList(response);
      });
  }, []);

  const updateData = (e: any) => {
    setData({
      ...data,
      [e.target.name]:
        e.target.type === "number" ? parseInt(e.target.value) : e.target.value,
    });
  };
  const handleChangeSwitch = (e: any) => {
    setToggleButton({
      ...data,
      [e.target.name]: e.target.value,
    });
  };

  const handleFormSubmit = (e: any) => {
    e.preventDefault();
    var token = Cookies.get("newJwt");
    setIsDownload(true);
    let extension = "";
    if (`${getTaskDownload}` === "pdf") {
      extension = "pdf";
    }
    if (`${getTaskDownload}` === "csv") {
      extension = "csv";
    }
    if (`${getTaskDownload}` === "excel") {
      extension = "xlsx";
    }
    const containsClientID = getMetaValue.some(
      (meta: any) => meta.name === "ClientID"
    );
    var raw =
      showControls?.returnType === "dataset"
        ? JSON.stringify({
            Type: `${getTaskDownload.toLocaleLowerCase()}`,
            data: {
              ...data,
              ...(containsClientID
                ? { ClientID: parseInt(selectedClient) }
                : null),
            },
          })
        : JSON.stringify({
            data: {
              ...data,
              ...(containsClientID
                ? { ClientID: parseInt(selectedClient) }
                : null),
            },
          });

    var requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: raw,
    };
    if (showControls?.returnType === "dataset") {
      fetch(
        `${BASE_URL}/${API_KEY}/api/metadata/${showControls?.id}/download`,
        requestOptions
      )
        .then((response) => {
          if (response.ok) {
            response.blob().then((blob) => {
              const fileURL = window.URL.createObjectURL(blob);
              let alink = document.createElement("a");
              alink.href = fileURL;
              alink.download = `sample.${extension}`;
              alink.click();
              setIsDownload(false);
              setDataSetErrorMsg("File downloaded successfully!");
            });
          } else {
            return response.json();
          }
        })

        .then((data) => {
          setDataSetErrorMsg(data);
          // Process the response data as needed
        })

        .catch((error) => {
          console.error(
            "An error occurred while downloading the file",
            error.message
          );
        });
    } else {
      fetch(
        `${BASE_URL}/${API_KEY}/api/metadata/${showControls?.id}/execute`,
        requestOptions
      )
        .then((response) => response.json())
        .then((data) => {
          setDataProcessErrorMsg(data); // Log the parsed JSON data
        })
        .catch((error) => {
          console.log(error);
        });
    }
  };

  useEffect(() => {
    FetchSecurityMaster(
      "Fund",
      parseInt(selectedClient),
      Cookies.get("newJwt")
    ).then((response) => {
      setFundList(response);
    });
    FetchSecurityMaster(
      "Participant",
      parseInt(selectedClient),
      Cookies.get("newJwt")
    ).then((response) => {
      setParticipantList(response);
    });
  }, []);

  const handleRadioChange = (event: any) => {
    setReturnType(event.target.value);
  };

  useEffect(() => {
    const returnTypeFilter = returnType || "dataset";
    const filteredOptions = filter(metaDataList, {
      returnType: returnTypeFilter,
    });
    setFilteredTaskOptions(filteredOptions);
    setSelectedId(null);
    setSelected([]);
    setDateValue("");
    setDataProcessErrorMsg(null);
    setDataSetErrorMsg(null);
    setData(null);
  }, [returnType, metaDataList]);

  const taskOptions: any = filteredTaskOptions?.map((e: any) => {
    return { label: e.name, value: e.id };
  });

  return (
    <div>
      <div className="header">
        <h1 className="header-title">Task</h1>
      </div>

      <div className="row w-100 card p-4">
        {dataSetErrorMsg ? (
          <div
            style={{ top: "-30px" }}
            className={`alert position-absolute start-0 px-4 ${
              dataSetErrorMsg?.errors?.length > 0
                ? "alert-danger"
                : "alert-success"
            } p-2`}
          >
            {dataSetErrorMsg?.errors?.length > 0 ? (
              <ul className="m-0 px-0 list-inline">
                {dataSetErrorMsg?.errors.map((error: any, index: number) => (
                  <li key={index}>{error.message}</li>
                ))}
              </ul>
            ) : (
              dataSetErrorMsg
            )}
          </div>
        ) : null}

        {dataProcessErrorMsg !== null ? (
          Array.isArray(dataProcessErrorMsg) ? (
            <div
              style={{ top: "-30px" }}
              className={`alert position-absolute start-0 px-4 ${
                dataProcessErrorMsg[0]?.ProcessResultDesc.includes("ERROR")
                  ? "alert-danger"
                  : "alert-success"
              } p-2`}
            >
              {dataProcessErrorMsg[0]?.ProcessResultDesc}
            </div>
          ) : (
            <div
              style={{ top: "-30px" }}
              className={`alert position-absolute start-0 px-4 ${
                dataProcessErrorMsg?.errors ? "alert-danger" : "alert-success"
              } p-2`}
            >
              {dataProcessErrorMsg?.errors?.map((error: any) => (
                <span key={error}>{error.message}</span>
              ))}
            </div>
          )
        ) : null}

        <div className="w-100 tradeForm position-relative">
          <div className="form-group row">
            <label className="col-sm-2 col-form-label">Select:</label>
            <div className="col-sm-10 px-2 d-flex">
              <div className="form-check">
                <input
                  className="form-check-input"
                  type="radio"
                  name="flexRadioDefault"
                  id="flexRadioDefault2"
                  value="dataset"
                  onChange={handleRadioChange}
                  checked={returnType === "dataset"}
                />
                <label className="form-check-label" htmlFor="flexRadioDefault2">
                  Data Views
                </label>
              </div>
              <div className="form-check mx-2">
                <input
                  className="form-check-input"
                  type="radio"
                  name="flexRadioDefault"
                  id="flexRadioDefault1"
                  value="dataprocess"
                  onChange={handleRadioChange}
                  checked={returnType === "dataprocess"}
                />
                <label className="form-check-label" htmlFor="flexRadioDefault1">
                  Data Process
                </label>
              </div>
            </div>
          </div>
          <div className="form-group row pt-2">
            <label className="col-sm-2 col-form-label">Task:</label>
            <div className="col-sm-10 px-2">
              {taskOptions ? (
                <MultiSelect
                  options={taskOptions}
                  value={selected}
                  hasSelectAll={false}
                  onChange={setSelected}
                  labelledBy="Select Benchmark"
                  className="multiSelect w-25 taskSelection"
                  closeOnChangedValue={true}
                />
              ) : null}

              {/* <select className="form-control w-25" onChange={handleChange}>
                <option>Select</option>
                {metaDataList ? (
                  metaDataList &&
                  metaDataList.map((e: any) => {
                    return (
                      <option key={e.id} id={e.id}>
                        {e.name}
                      </option>
                    );
                  })
                ) : (
                  <option value="">Loading...</option>
                )}
              </select> */}
            </div>
          </div>

          <form onSubmit={handleFormSubmit}>
            {/* {selectedId &&
            selectedId !== null &&
            selectedName !== "GetUserList" &&
            selectedId !== "295a0a04-3363-4b43-9cb4-4f34d59c6ba9" &&
            selectedId !== "6982dd6e-a482-4fb5-b103-2028e454a6d8" &&
            selectedId !== "295a0a04-3363-4b43-9cb4-4f34d59c6ba9" ? (
              <>
                <div className="form-group row my-4">
                  <div className="d-flex py-2">
                    <label className="col-sm-2 col-form-label">
                      {getMetaValue?.map((e: any) => {
                        return e.label;
                      })}{" "}
                    </label>
                    {getMetaValue?.map((e: any) => {
                      return e.type === "date" ? (
                        <>
                          <div className="col-sm-10">
                            <input
                              type={e.type}
                              placeholder="mm-dd-yyyy"
                              className="form-control w-25"
                              name={e.label}
                              onChange={updateData}
                            />
                          </div>
                        </>
                      ) : null;
                    })}{" "}
                  </div>
                </div>
              </>
            ) : null} */}
            {/* {selectedName &&
            selectedName === "ExportSecurityPositionsData" &&
            selectedDate !== "" ? (
              <>
                <div className="form-group row my-4">
                  <label className="col-sm-2 col-form-label">Download</label>
                  <div className="col-sm-10">
                    <select
                      className="form-control w-25"
                      onChange={handleDownload}
                    >
                      <option>Excel</option>
                      <option>CSV</option>
                      <option>PDF</option>
                    </select>
                  </div>
                </div>
                <div className="col-sm-12">
                  <Button
                    children="Download"
                    type="button"
                    className="btn btn-primary float-end"
                    size="btn-xs"
                    onClick={handleDownloadFile}
                    showLoading={isDownload}
                  />
                </div>
              </>
            ) : null} */}
            {selectedId && selectedId !== null ? (
              <>
                <div className="form-group row py-2">
                  {getMetaValue?.map((e: any) => {
                    return e.parameterType === "IN" &&
                      e.label !== "ClientID" ? (
                      <div className="d-flex py-2">
                        <label className="col-form-label col-sm-2">
                          {e.label}
                        </label>

                        <div className="col-sm-10">
                          {/* {e.name === "FundID" ? (
                            <select
                              className="form-control w-25"
                              name={e.label}
                              onChange={updateData}
                            >
                              
                              {getFundList?.map((item: any) => {
                                return (
                                  <option
                                    defaultValue="select"
                                    value={item.fundID}
                                  >
                                    {item.fundName}
                                  </option>
                                );
                              })}
                            </select>
                          ) : null} */}
                          {e.inputType === "select" ? (
                            <>
                              {e.options.length > 0 ? (
                                <select
                                  className="form-control w-25"
                                  name={e.label}
                                  onChange={updateData}
                                  key={selected}
                                >
                                  <option value="">Select</option>

                                  {e.options.map((item: any) => {
                                    return (
                                      <option value={item.value}>
                                        {item.label}
                                      </option>
                                    );
                                  })}
                                </select>
                              ) : (
                                <select
                                  className="form-control w-25"
                                  name={e.label}
                                  onChange={updateData}
                                  key={selected}
                                >
                                  <option value="">Select</option>

                                  {e.inputDataSource.map((item: any) => {
                                    return (
                                      <option
                                        value={item?.parameterData?.[0].key}
                                      >
                                        {item?.parameterData?.[0].val}
                                      </option>
                                    );
                                  })}
                                </select>
                              )}
                            </>
                          ) : null}
                          {e.inputType === "SelectList" ? (
                            <select
                              className="form-control w-25"
                              name={e.label}
                              onChange={updateData}
                              key={selected}
                            >
                              <option value="">Select</option>
                              <option value="">
                                {e.inputDataSource.map((item: any) => {
                                  return item.value;
                                })}
                              </option>
                            </select>
                          ) : null}
                          {e.label === "FundID" || e.label === "Fund" ? (
                            <select
                              className="form-control w-25"
                              name={e.name}
                              onChange={updateData}
                              key={selected}
                            >
                              <option value="">Select</option>
                              {fundList?.map((fund: any) => {
                                return (
                                  <option value={fund.fundID} key={fund.fundID}>
                                    {fund.fund}- {fund.fundName}
                                  </option>
                                );
                              })}
                            </select>
                          ) : null}
                          {e.label === "ParticipantID" ||
                          e.label === "Participant" ? (
                            <select
                              className="form-control w-25"
                              name={e.name}
                              onChange={updateData}
                              key={selected}
                            >
                              <option value="">Select</option>
                              {participantList?.map((e: any) => {
                                return (
                                  <option
                                    value={e.participantID}
                                    key={e.participantID}
                                  >
                                    {e.participantNumber}- {e.participantName}
                                  </option>
                                );
                              })}
                            </select>
                          ) : null}
                          {e.inputType === "text" ? (
                            <input
                              type={e.inputType}
                              placeholder={e.placeHolder}
                              name={e.label}
                              className="form-control w-25"
                              onChange={updateData}
                              key={selected}
                            />
                          ) : null}
                          {e.inputType === "file" ? (
                            <input
                              type={e.inputType}
                              placeholder={e.placeHolder}
                              className="form-control w-25"
                              name={e.label}
                              onChange={updateData}
                            />
                          ) : null}
                          {e.inputType === "number" &&
                          e.label !== "FundID" &&
                          e.label !== "ParticipantID" &&
                          e.label !== "Fund" &&
                          e.label !== "Participant" &&
                          e.label !== "ClientID" ? (
                            <input
                              type={e.inputType}
                              placeholder={e.placeHolder}
                              className="form-control w-25"
                              name={e.label}
                              onChange={updateData}
                              key={selected}
                            />
                          ) : null}
                          {e.inputType === "maskedtext" ? (
                            <input
                              type="text"
                              placeholder={e.placeHolder}
                              className="form-control w-25"
                              name={e.name}
                              onChange={updateData}
                              key={selected}
                            />
                          ) : null}
                          {e.inputType === "date" &&
                          e.dbType === "smalldatetime" ? (
                            <input
                              type="date"
                              placeholder="mm-dd-yyyy"
                              className="form-control w-25"
                              name={e.label}
                              onChange={handleDateChange}
                              key={selected}
                            />
                          ) : null}
                          {e.inputType === "date" && e.dbType === "datetime" ? (
                            <input
                              type="datetime-local"
                              placeholder="mm-dd-yyyy"
                              className="form-control w-25"
                              name={e.label}
                              onChange={handleDateChange}
                              key={selected}
                            />
                          ) : null}
                          {e.inputType === "textarea" ? (
                            <textarea
                              placeholder={e.placeHolder}
                              className="form-control w-25"
                              //rows="3"
                              name={e.label}
                              onChange={updateData}
                              key={selected}
                            />
                          ) : null}
                          {e.inputType === "radio" ? (
                            <>
                              <form name={e.name} onChange={updateData}>
                                {e.options.map((item: any) => {
                                  return (
                                    <div className="form-check form-check-inline py-1">
                                      <input
                                        className="form-check-input"
                                        type="radio"
                                        id="inlineRadio1"
                                        value={item.value}
                                        name={e.name}
                                      />
                                      <label
                                        className="form-check-label"
                                        htmlFor="inlineRadio1"
                                      >
                                        {item.label}
                                      </label>
                                    </div>
                                  );
                                })}
                              </form>
                            </>
                          ) : null}

                          {e.inputType === "checkboxgroup" ? (
                            <form name={e.name} onChange={updateData}>
                              {e.options.map((item: any) => {
                                return (
                                  <div className="form-check form-check-inline py-1">
                                    <input
                                      type="checkbox"
                                      placeholder={e.placeHolder}
                                      className="form-check-input my-2"
                                      name={e.label}
                                      onChange={updateData}
                                    />
                                    <label
                                      className="form-check-label py-1"
                                      htmlFor="inlineCheckBOx1"
                                    >
                                      {item.label}
                                    </label>
                                  </div>
                                );
                              })}
                            </form>
                          ) : null}

                          {e.inputType === "switch" ? (
                            <Switch
                              checked={ToggleButton}
                              onChange={handleChangeSwitch}
                              onColor="#33B271"
                              onHandleColor="#fff"
                              handleDiameter={30}
                              uncheckedIcon={false}
                              checkedIcon={false}
                              boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                              activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                              height={20}
                              width={48}
                              className="react-switch my-2"
                              name={e.label}
                              //onChange={() => updateData((current:any) => !current)}
                            />
                          ) : null}
                          {e.inputType === "button" ? (
                            <button className="btn btn-primary">
                              {e?.label}
                            </button>
                          ) : null}
                        </div>
                      </div>
                    ) : null;
                  })}{" "}
                  {showControls?.allowExecute === true &&
                  showControls?.returnType === "dataset" ? (
                    <div className="d-flex py-2">
                      <label className="col-sm-2 col-form-label">
                        Download
                      </label>
                      <div className="col-sm-10">
                        <select
                          className="form-control w-25"
                          onChange={handleDownload}
                          key={selected}
                        >
                          <option value="">Select</option>

                          {showControls?.allowPdfExport === true && (
                            <option value="pdf">PDF</option>
                          )}
                          {showControls?.allowCsvExport === true && (
                            <option value="csv">CSV</option>
                          )}
                          {showControls?.allowExcelExport === true && (
                            <option value="excel">Excel</option>
                          )}
                        </select>
                      </div>
                    </div>
                  ) : null}
                  <div className="col-sm-12 my-4 p-0">
                    <button
                      type="button"
                      className="btn d-inline-flex align-items-center btn-xs btn btn-link float-start"
                    >
                      {showControls?.cancelButtonText !== null
                        ? showControls?.cancelButtonText
                        : "Cancel"}
                    </button>
                    <button
                      type="submit"
                      className="btn d-inline-flex align-items-center btn-xs btn btn-primary float-start mx-4"
                    >
                      {showControls?.submitButtonText !== null
                        ? showControls?.submitButtonText
                        : "Submit"}
                    </button>
                  </div>
                </div>
              </>
            ) : null}
          </form>
          {selectedName && selectedName === "ProcessSecurityPositionsData" ? (
            <div className="col-sm-12 mb-4">
              <Button
                children="Submit"
                type="button"
                className="btn btn-primary float-end"
                size="btn-xs"
                onClick={handleProcessSecurity}
                showLoading={isDownload}
              />
            </div>
          ) : null}
          {selectedName &&
          selectedName === "GetSecurityPositionsData" &&
          selectedDate !== "" ? (
            <TableData
              selectedId={selectedId}
              selectedDate={selectedDate}
              getExecuteValue={getExecuteValue}
              sectorCount={sectorCount}
              SectorpageHandler={SectorpageHandler}
              SectorCurrentPage={SectorCurrentPage}
            />
          ) : null}
        </div>
      </div>
    </div>
  );
};

export { TaskList };
